<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">评价详情</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" ref="editForm" disabled>
                    <div>
                        <el-row>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>订单详情</span>
                                </div>
                                <el-row>
                                    <el-col :span="16" class="item">
                                        <el-form-item label="标题">
                                            <el-input v-model="goodsName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-col :span="8" class="item">
                                    <el-form-item label="价格">
                                        <el-input v-model="goodsPrice"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="购买数量">
                                        <el-input v-model="number"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="商家">
                                        <el-input v-model="businessName" ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="是否是预订单">
                                        <el-select v-model="isSchedule">
                                            <el-option
                                                    v-for="(item,index) in isScheduleValue"
                                                    :key="index"
                                                    :label="item"
                                                    :value="index">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="订单类型">
                                        <el-select v-model="orderType">
                                            <el-option
                                                    v-for="(item,index) in orderTypeValue"
                                                    :key="index"
                                                    :label="item"
                                                    :value="index">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="订单状态">
                                        <el-select v-model="status">
                                            <el-option
                                                    v-for="(item,index) in statusValue"
                                                    :key="index"
                                                    :label="item"
                                                    :value="index">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>评价</span>
                                </div>
                                <el-col :span="8" class="item">
                                    <el-form-item label="评价人姓名">
                                        <el-input v-model="receiveName" ></el-input>
                                    </el-form-item>
                                </el-col>
                                 <el-col :span="8" class="item">
                                    <el-form-item label="评价人手机号">
                                        <el-input v-model="receivePhone" ></el-input>
                                    </el-form-item>
                                </el-col>
                                 <el-col :span="24" class="item">
                                    <el-form-item label="评价内容">
                                        <el-input v-model="remarks" type="textarea" ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                        </el-row>
                    </div>

                </el-form>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'AppraiseInfo',
        data() {
            return {
                loading: false,
                goodsName:'',
                goodsPrice:'',
                number:'',
                businessName:'',
                isSchedule:'',
                orderType:'',
                status:'',
                remarks:'',
                receiveName:'',
                receivePhone:'',
                receiveAreaPath:'',
                editForm:{},
                isScheduleValue:['否','是'],
                statusValue:['待付款','待发货','待收货','交易成功','退款中','交易关闭','交易取消','已评价',"","",'待付款','待接单','已接单','服务中','服务完成','交易取消','已评价'],
                orderTypeValue:["",'普通商品订单','社会化服务订单','政府购买服务订单'],
            }
        },

        methods: {

            init(row){
                console.log(row);
                this.remarks=row.remarks
                this.goodsName=row.orderGoodsDTOList[0].goodsName
                this.goodsPrice=row.orderGoodsDTOList[0].goodsPrice
                this.number=row.orderGoodsDTOList[0].number
                this.businessName=row.orderBusiness.businessName
                this.isSchedule=row.orderBusiness.isSchedule
                this.orderType=row.orderBusiness.orderType
                this.status=row.orderBusiness.status
                this.receiveName=row.elderlyDTO.name
                this.receivePhone=row.elderlyDTO.userPhone
                this.receiveAreaPath=row.elderlyDTO.zoneName
            },

            closeSelf() {
                this.$emit("closeAppraiseInfo");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })


            },
            changeStatus:function (selVal) {
                this.editForm.status = selVal;
            },
            handleImgSuccess(res, file) {
                 console.log(file)
                this.editForm.icon = this.$imgUrl+res.data.path;
            },
            iconPreview() {
                this.iconDialog = true;
            },

        }
    }


</script>




<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 800px;
            .modal-body /deep/ .el-upload--picture-card{
                width: 100px;
                height: 100px;
                line-height: 100px;
            }
            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 0 0 20px 0px;
                z-index: 99;
                overflow-y:scroll;
                max-height: 500px;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-body /deep/ .el-input.is-disabled .el-input__inner {
                color: #000;
            }
            .modal-body /deep/ .el-textarea.is-disabled .el-textarea__inner {
                color: #000;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }
            .uploadButton{
                border-top: 1px solid #eee;
                padding: 10px 0 0;
                display: flex;
                 .el-button{
                    width: 100px;
                }
            }

        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
